(function () {
  function createCookie(name, value, minutes) {
    var expires;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/";
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  const headerHandlers = () => {
    const $header = document.querySelector("#shopify-section-header");
    const $dropdownItems = document.querySelectorAll(
      "#shopify-section-header .nav-item.has-dropdown"
    );
    const isCollectionPage = location.pathname
      .split("/")
      .includes("collections");
    const scrollThreshold = isCollectionPage ? 25 : 50;

    function handleMouseEnter(event) {
      let $item = event.currentTarget;
      $header.classList.add("scrolled");
    }

    function handleMouseLeave(event) {
      let top = window.scrollY;
      if (top < 100) {
        $header.classList.remove("scrolled");
      }
    }

    [...$dropdownItems].forEach(function ($item) {
      $item.addEventListener("mouseenter", handleMouseEnter);
      $item.addEventListener("mouseleave", handleMouseLeave);
    });

    window.addEventListener(
      "scroll",
      function (event) {
        var top = this.scrollY,
          left = this.scrollX;

        if (top > scrollThreshold) {
          $header.classList.add("scrolled");
        } else {
          if (!$header.matches(":hover")) {
            $header.classList.remove("scrolled");
          } else {
            function handleLeave() {
              $header.classList.remove("scrolled");
              $header.removeEventListener("mouseleave", handleLeave);
            }

            $header.addEventListener("mouseleave", handleLeave);
          }
        }
      },
      false
    );
  };

  const productFeeds = () => {
    const $feeds = document.querySelectorAll(
      ".product-feed-list .nosto_element"
    );

    function startFeed($feed) {
      const $list = $feed.querySelector(".nosto-list");

      if (!$list)
        return setTimeout(function () {
          startFeed($feed);
        }, 500);

      $($list).slick({
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    console.log('PRODUCT FEED NOSTO LISTS', $feeds);

    [...$feeds].forEach(function ($feed) {
      startFeed($feed);
    });
  };

  const fixedEmailModal = () => {
    const $modal = document.querySelector(".fixed-email-modal-wrapper");
    const $closer = $modal.querySelector("#fixed-close");

    $closer.addEventListener("click", function (event) {
      $modal.style.display = "none";
      createCookie("JMKlaviyo", "closed");
    });

    if(!window.KlaviyoSubscribe) return setTimeout(fixedEmailModal, 1500);
    // Klaviyo attachment for the fixed modal.
    window.KlaviyoSubscribe.attachToForms("#email_signup_fixed_modal", {
      hide_form_on_success: true,
      success: function ($form) {
        createCookie("JMKlaviyo", "subscribed");
        $(".fixed-email-modal-wrapper").hide();
        // $('.klaviyo_field_group.select-date-widget').hide();
      },
    });

    if (!readCookie("JMKlaviyo")) {
      $modal.style.display = "block";
    }
  };

  const footer = () => {
    const $chatTrigger = document.querySelector(".chat-trigger");

    if ($chatTrigger) {
      $chatTrigger.addEventListener("click", function (event) {
        event.preventDefault();
        tidioChatApi.popUpOpen();
      });
    }
  };

  function getCartPromise() {
    return new Promise(function (resolve, reject) {
      JM.MiniCart.getCart(function (cart) {
        resolve(cart);
      });
    });
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  $(document).on(
    "click",
    ".nosto-cart-wrapper .nosto-btn",
    async function (event) {
      let $btn = event.currentTarget;
      let $item = $btn.closest(".nosto-list-item");
      let $items = $item.parentElement.querySelectorAll(".nosto-list-item");

      let $nextItem = [...$items].find(function ($nosto, index) {
        return (
          $nosto !== $item &&
          index > 1 &&
          $nosto.style.display !== "none" &&
          $nosto.style.display !== "flex"
        );
      });

      console.log("Button Click?", { $btn });

      $item.style.display = "none";
      $nextItem.style.display = "flex";
      await sleep(500);

      let cart = await getCartPromise();

      console.log("Update Nosto Cart", cart);

      JM.MiniCart.populateContainer(cart);

      setTimeout(init_cart_slider, 150);
    }
  );

  async function init_cart_slider() {
    let cart = await getCartPromise();

    let allFragrance = [...cart.items].every(
      (item) => item.handle.indexOf("fragrance") > -1
    );

    $(".product-slider").slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      nextArrow:
        '<span class="slide-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
      prevArrow:
        '<span class="slide-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>',
    });

    const slickData = $(".product-slider").slick("getSlick");

    if (slickData.slideCount > 0) {
      $(".cart-upsell").removeClass("hide");
    }

    // Nosto Carousel
    setTimeout(() => {
      $("#nosto_cartdrawer .nosto-list").slick({ slidesToShow: 2 });
      setTimeout(() => {
        $("#nosto_cartdrawer .nosto-list").slick("setPosition");
      }, 150);
    }, 750);

    if (document.querySelector("#cart-preview-dropdown .cart-note"))
      document.querySelector(
        "#cart-preview-dropdown .cart-note"
      ).style.display = allFragrance ? "none" : "block";
    console.log("Slick Test", $(".product-slider").slick("getSlick"), cart);
  }

  $("#ajax-trigger").on("click", function (e) {
    e.preventDefault();
    //   donation_added();
    $("#cart-preview-dropdown").toggleClass("is-open");
    init_cart_slider();
    nostojs(function (api) {
      api.loadRecommendations();
    });
  });

  /***********Close Cart on click close icon*************/
  $("body").on("click", ".cart-close", function (e) {
    $("#cart-preview-dropdown").removeClass("is-open");
  });
  /***********Close Cart on click close icon*************/

  footer();
  fixedEmailModal();
  productFeeds();
  headerHandlers();
  console.log('Layout JS');
})();
